module.exports = __webpack_public_path__ + "7d517d9b58f3780f32a9fd3835227560.pdf";